/* eslint-disable */
import React, { Component } from 'react';
import { t } from './i18n';

// เนื้อหาสูตร (static) — แก้/เพิ่มได้ที่นี่
const STRATEGIES = [
  { icon: '🃏', color: '#c10655', name: 'บาคาร่า', tip: 'เดินเงินแบบ 1-3-2-6 คุมทุนต่อไม้ ไม่ไล่เกิน 4 ไม้ติด ออกฝั่งเดิมเกาะกระแสน้ำ ตัดขาดทุนเมื่อถึงเป้า' },
  { icon: '🎰', color: '#7b2ff7', name: 'สล็อต', tip: 'เลือกเกม RTP สูง (96%+) เริ่มเดิมพันต่ำสุดดูจังหวะแตก ปรับเพิ่มตอนโบนัสมา ตั้งเป้ากำไร 30-50% แล้วถอน' },
  { icon: '🎲', color: '#e8821e', name: 'ไฮโล', tip: 'แทงสูง/ต่ำเป็นหลักโอกาส 48% เก็บกำไรทีละน้อย หลีกเลี่ยงแทงเลขเดี่ยวจ่ายสูงแต่ออกยาก คุมงบต่อรอบ' },
  { icon: '🐯', color: '#0f9d58', name: 'เสือมังกร', tip: 'เกมไพ่ใบเดียว ตัดสินไว ดูสถิติ 10 ตาล่าสุดจับทางฝั่งที่ออกถี่ ไม่แทงเสมอ (จ่ายสูงแต่เปอร์เซ็นต์ต่ำ)' },
  { icon: '🎯', color: '#1565c0', name: 'รูเล็ต', tip: 'แทงกลุ่มใหญ่ (แดง/ดำ, คู่/คี่) โอกาสเกือบ 50% ใช้สูตร Martingale อย่างมีลิมิต อย่าไล่จนเกินทุน' },
  { icon: '🐟', color: '#00acc1', name: 'ยิงปลา', tip: 'เล็งปลาตัวเล็กเก็บกระสุนคืนทุนก่อน เก็บปลาใหญ่ตอนกระสุนพอ ใช้ปืนเลเวลกลางคุ้มสุด ยิงโบนัส/ฉลามรวมหัว' },
];

class Strategy extends Component {
  get lang() { return localStorage.getItem('lang') || 'th'; }

  render() {
    const lang = this.lang;
    return (
      <div className="container p-0 x-margin-top-v3">
        <div className="row m-0 border-shadow-title">
          <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
            <div className="text-center bg-title-web">
              <div className="text-title text-white-v1 text-center">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <a role="button" href="/" style={{ cursor: 'pointer' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="currentColor" className="bi bi-arrow-left-circle text-white" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                    </svg>
                  </a>
                  <h5 className="m-0">{t(lang, 'strategy_title')}</h5>
                  <div style={{ width: 25 }} />
                </div>
                <hr className="mt-0" />
              </div>
            </div>

            <div className="p-2 bg-profile-box-overview animated animatedFadeInUp fadeInUp">
              <div className="text-center mb-3">
                <span className="text-white-v1" style={{ fontSize: 13, opacity: 0.75 }}>{t(lang, 'strategy_subtitle')}</span>
              </div>
              {STRATEGIES.map((s, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'flex-start', gap: 12,
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  borderRadius: 14, padding: '14px 14px', marginBottom: 10,
                }}>
                  <div style={{
                    width: 46, height: 46, borderRadius: 12, flexShrink: 0,
                    background: s.color, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 24, boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                  }}>{s.icon}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ color: '#fff', fontWeight: 700, fontSize: 15, marginBottom: 4 }}>
                      {t(lang, 'strategy_prefix')} {s.name}
                    </div>
                    <div style={{ color: 'rgba(255,255,255,0.72)', fontSize: 13, lineHeight: 1.6 }}>{s.tip}</div>
                  </div>
                </div>
              ))}
              <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.45)', fontSize: 12, marginTop: 8, lineHeight: 1.6 }}>
                {t(lang, 'strategy_note')}
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Strategy;
